// Cart Upsell — Mercier
const UPSELL_CONTAINER_ID = 'mercier-upsell';
const REASSURANCE_ID = 'mercier-reassurance';
const REASSURANCE_TEXT = 'Retour offert sous 30 jours · Expédié sous 24 h · Paiement sécurisé';
const MAX_PRODUCTS = 8;                // nombre de vignettes affichées
const INSERT_POSITION = 'beforebegin'; // 'beforebegin' = au-dessus du bouton | 'afterend' = en dessous

let upsellProducts = [];
let isInjecting = false;

async function fetchUpsellProducts() {
  const res = await fetch('/collections/upsell-accessoires/products.json?limit=20');
  const data = await res.json();
  return (data.products || []).map(p => {
    const v = p.variants.find(x => x.available) || p.variants[0];
    return {
      title: p.title,
      handle: p.handle,
      image: p.images[0]?.src || '',
      price: Math.round(Number(v?.price) * 100),
      variantId: v?.id,
      available: !!v?.available
    };
  }).filter(p => p.available && p.variantId);
}

async function getCartState() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  return {
    total: cart.total_price,
    variantIds: cart.items.map(i => i.variant_id)
  };
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

// Ordre de la collection respecté — seul filtre : les articles déjà au panier
function selectProducts(all, cart) {
  const inCart = new Set(cart.variantIds.map(String));
  return all
    .filter(p => !inCart.has(String(p.variantId)))
    .slice(0, MAX_PRODUCTS);
}

function renderUpsell(products, container) {
  if (!products.length) { container.innerHTML = ''; return; }
  container.innerHTML = `
    <div style="padding: 0.7rem 0 0.3rem; border-top: 1px solid rgba(0,0,0,0.1); margin-top: 0.4rem;">
      <p style="font-size: 0.66rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin: 0 0 0.45rem; color: inherit;">Complétez votre équipement</p>
      <div id="upsell-carousel" style="display: flex; gap: 0.5rem; overflow-x: auto; scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch; padding-bottom: 0.2rem; scrollbar-width: none;">
        ${products.map(p => `
          <div style="scroll-snap-align: start; text-align: left;">
            <div>
              <a href="/products/${p.handle}" style="display:block;">
                <img src="${p.image}" alt="${p.title}" loading="lazy">
              </a>
              <button onclick="upsellAddToCart('${p.variantId}', this)"
                aria-label="Ajouter ${p.title}"
                style="position:absolute; bottom:3px; right:3px; width:20px; height:20px; line-height:1; font-size:0.8rem; cursor:pointer; border:1px solid rgba(0,0,0,0.15); background:rgba(255,255,255,0.94); color:#111; border-radius:50%; padding:0; display:flex; align-items:center; justify-content:center; z-index:2;">+</button>
            </div>
            <a href="/products/${p.handle}" style="text-decoration:none; color:inherit; display:block; margin-top:0.25rem;">
              <p style="font-size:0.62rem; line-height:1.2; margin:0;">${p.title}</p>
              <p style="font-size:0.64rem; font-weight:600; margin:0;">${formatMoney(p.price)}</p>
            </a>
          </div>
        `).join('')}
      </div>
    </div>
  `;
  if (!document.getElementById('upsell-style')) {
    const style = document.createElement('style');
    style.id = 'upsell-style';
    style.textContent = `
      #upsell-carousel::-webkit-scrollbar { display: none; }
      #upsell-carousel > div { flex: 0 0 76px !important; width: 76px !important; }
      #upsell-carousel > div > div { position: relative !important; width: 76px !important; height: 76px !important; overflow: hidden !important; border-radius: 2px; }
      #upsell-carousel img { width: 76px !important; height: 76px !important; object-fit: cover !important; display: block !important; max-width: none !important; aspect-ratio: auto !important; }
      #upsell-carousel p { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      @media (max-width: 749px) {
        #upsell-carousel > div { flex: 0 0 68px !important; width: 68px !important; }
        #upsell-carousel > div > div { width: 68px !important; height: 68px !important; }
        #upsell-carousel img { width: 68px !important; height: 68px !important; }
      }
    `;
    document.head.appendChild(style);
  }
}

window.upsellAddToCart = async function(variantId, btn) {
  btn.disabled = true;
  btn.textContent = '·';

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
  });

  const data = await res.json();

  if (data.sections?.['cart-drawer']) {
    const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
    const newDrawerContent = doc.querySelector('#cart-drawer');
    const currentDrawer = document.querySelector('#cart-drawer');
    if (newDrawerContent && currentDrawer) {
      currentDrawer.innerHTML = newDrawerContent.innerHTML;
    }
  }

  setTimeout(async () => {
    isInjecting = false;
    await injectUpsell();
    injectReassurance();
  }, 100);
};

async function injectUpsell() {
  if (isInjecting) return;
  isInjecting = true;

  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) { isInjecting = false; return; }
  if (drawer.querySelector(`#${UPSELL_CONTAINER_ID}`)) { isInjecting = false; return; }

  const upsellDiv = document.createElement('div');
  upsellDiv.id = UPSELL_CONTAINER_ID;

  const checkout = drawer.querySelector('[name="checkout"], .cart__checkout, a[href="/checkout"]');
  if (checkout) {
    const checkoutParent = checkout.closest('div, form, p') || checkout.parentNode;
    checkoutParent.insertAdjacentElement(INSERT_POSITION, upsellDiv);
  } else {
    drawer.appendChild(upsellDiv);
  }

  if (!upsellProducts.length) {
    upsellProducts = await fetchUpsellProducts();
  }
  const cart = await getCartState();
  renderUpsell(selectProducts(upsellProducts, cart), upsellDiv);
  isInjecting = false;
}

// Réassurance — sous le bouton de commande
function injectReassurance() {
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;
  if (drawer.querySelector(`#${REASSURANCE_ID}`)) return;

  const checkout = drawer.querySelector('[name="checkout"], .cart__checkout, a[href="/checkout"]');
  if (!checkout) return;

  const el = document.createElement('p');
  el.id = REASSURANCE_ID;
  el.textContent = REASSURANCE_TEXT;
  el.style.cssText = 'font-size:0.65rem; line-height:1.4; text-align:center; opacity:0.6; margin:0.55rem 0 0; color:inherit;';

  const parent = checkout.closest('div, form, p') || checkout.parentNode;
  parent.insertAdjacentElement('afterend', el);
}

// Observer — résiste aux re-rendus de section (éditeur de thème, ajout au panier)
if (!window.__upsellObserverInit) {
  window.__upsellObserverInit = true;

  const scheduleInject = () => {
    clearTimeout(window.__upsellTimer);
    window.__upsellTimer = setTimeout(() => {
      isInjecting = false;
      injectUpsell();
      injectReassurance();
    }, 150);
  };

  new MutationObserver(() => {
    const d = document.querySelector('#cart-drawer');
    if (!d) return;
    const missing = !d.querySelector(`#${UPSELL_CONTAINER_ID}`) || !d.querySelector(`#${REASSURANCE_ID}`);
    if (missing && !isInjecting) scheduleInject();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'class']
  });

  document.addEventListener('shopify:section:load', scheduleInject);
  document.addEventListener('shopify:section:select', scheduleInject);
  document.addEventListener('shopify:section:unload', scheduleInject);

  scheduleInject();
}